import { FunctionComponent } from "react";

import {
  TenantPromotionCodeSelect,
  TenantPromotionCodeSelectProps
} from "../../pickers/TenantPromotionCodeSelect";
import { FieldItem, useFieldContext, useFieldRegister } from "@bps/fluent-ui";

type FormTenantPromotionCodeSelectProps = Omit<
  TenantPromotionCodeSelectProps,
  "selectedKeys" | "onChangeSelectedKeys" | "label"
> & { label?: string; name: string };

export const FormTenantPromotionCodeSelect: FunctionComponent<FormTenantPromotionCodeSelectProps> = ({
  name,
  required,
  label,
  disabled,
  ...rest
}) => {
  useFieldRegister(name);
  const { value, setFieldValue, meta, disabledForm } = useFieldContext<
    string[] | undefined
  >(name);

  return (
    <FieldItem
      name={name}
      required={required}
      label={label}
      disabled={disabled || disabledForm}
      errorMessage={meta?.error}
    >
      <TenantPromotionCodeSelect
        disabled={disabled || disabledForm}
        selectedKeys={value}
        onChangeSelectedKeys={setFieldValue}
        {...rest}
      />
    </FieldItem>
  );
};
